import { useEffect, useState } from 'react';
import { useSelectSearchDoctorAttendingListOnOfficeViewModel } from '../select-search/use-select-search-doctor-attending-office.viewmodel';
import {
  AccountingFieldState,
  validateAccountingDoctolibCsvFile,
} from './accounting-doctolib-csv-file.validator';
import { ImportAccountingDoctorAttendingCsvUseForm } from './use-import-accounting-doctor-attending-csv-form';

export const useImportAccountingDoctorAttendingCsvFormViewModel = ({
  form,
}: {
  form: ImportAccountingDoctorAttendingCsvUseForm;
}) => {
  const officeId = form.watch('officeId');
  const csvFile = form.watch('doctolibAccountingFile');
  const doctorAttendings = useSelectSearchDoctorAttendingListOnOfficeViewModel({
    officeId,
  });
  const [formState, setFormState] = useState<{
    [key: string]: AccountingFieldState | null;
  }>({});

  // Validate csv file
  useEffect(() => {
    if (!csvFile) {
      return;
    }

    validateAccountingDoctolibCsvFile(csvFile)
      .then((state) => {
        setFormState((value) => {
          return {
            ...value,
            doctolibAccountingFile: state,
          };
        });
      })
      .catch(() => {
        setFormState((value) => {
          return {
            ...value,
            doctolibAccountingFile: {
              type: 'error',
              message:
                'import-accounting-doctor-attending-csv-form.import-csv.error.failed-to-validate-csv',
            },
          };
        });
      });
  }, [csvFile]);

  return {
    officeId,
    doctorAttendings,
    formState,
  };
};
